export const ErrorType = {
  generalError: "generalError",
  promiseError: "promiseError",
  vueCatchError: "vueCatchError",
  tryCatchError: "tryCathError",
};

export const __DEV__ = process.env.NODE_ENV === "local";
